import React from 'react';

export default function ListRow({ children }) {
	return <div className='row mb-3 pb-1 d-flex justify-content-between border-bottom border-light'>{children}</div>;
}
